import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Error {
  response: {
    status: number
  }
}

interface CreateReservationApiResponse {
  data: {
    hour: string
    start_date: string
    weekday: string
    non_recurrent_reservations?: {
      successful: {
        start_date: string
        end_date: string
      }[]
      errors: {
        [date: string]: string
      }
    }
  }
}

export interface Reservation {
  hour: string
  startDate: Date
  weekday: string
  weekdayPlural: string 
  nonRecurrentReservations?: {
    successful: {
      startDate: string
      endDate: string
    }[]
    errors: {
      [date: string]: string
    }
  }
}

interface CreateReservationProps {
  professionalUuid: string
  patientUsername: string
  reservationStartDate: string
  reservationEndDate: string
  recurrent: boolean
  nonRecurrentReservations?: {
    start_date: string
    end_date: string
  }[]
}

export const createReservation = ({
  professionalUuid,
  patientUsername,
  reservationStartDate,
  reservationEndDate,
  recurrent,
  nonRecurrentReservations
}: CreateReservationProps): Promise<Reservation> => {

  const endpoint = apiEndpoints.RESERVATION

  const params = {
    start_date: reservationStartDate,
    end_date: reservationEndDate,
    patient_username: patientUsername,
    professional_uuid: professionalUuid,
    recurrent,
    ...(nonRecurrentReservations && { non_recurrent_reservations: nonRecurrentReservations })
  }

  return new Promise<Reservation> ((resolve, reject) => {
    axios.post(endpoint, params)
      .then((apiResponse: CreateReservationApiResponse) => {
        const result = {} as Reservation
        const reservationBody = apiResponse.data

        result.hour = reservationBody.hour
        result.startDate = new Date(reservationBody.start_date)
        result.weekday = reservationBody.weekday
        result.weekdayPlural = reservationBody.weekday.split('-').map((word) => `${word}s`).join('-')

        const nonRecurrentFromApi = reservationBody?.non_recurrent_reservations
        if (
          nonRecurrentFromApi &&
          (nonRecurrentFromApi.successful?.length ||
            Object.keys(nonRecurrentFromApi.errors || {}).length)
        ) {
          result.nonRecurrentReservations = {
            successful: (nonRecurrentFromApi.successful ?? []).map((interval) => ({
              startDate: interval.start_date,
              endDate: interval.end_date
            })),
            errors: nonRecurrentFromApi.errors ?? {}
          }
        }

        resolve(result)
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}